import { useState, useEffect } from 'react';
import { WifiOff, RefreshCw, Check } from 'lucide-react';
import * as Tooltip from '@radix-ui/react-tooltip';
import { syncEngine } from '@/shared/sync/SyncEngine';
import styles from './SyncStatus.module.css';

export function SyncStatus() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [outboxCount, setOutboxCount] = useState(0);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Poll sync status every 10 seconds
    const interval = setInterval(async () => {
      const status = syncEngine.getStatus();
      setIsOnline(status.online);
      await syncEngine.refreshOutboxCount();
      setOutboxCount(syncEngine.getStatus().outboxCount);
    }, 10000);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
      clearInterval(interval);
    };
  }, []);

  const label = !isOnline
    ? 'Offline — changes will sync when reconnected'
    : outboxCount > 0
      ? `${outboxCount} pending in outbox`
      : 'Synced';

  const dotColor = !isOnline ? 'var(--color-accent-danger, #e53e3e)' : outboxCount > 0 ? 'var(--color-accent-warning, #f59e0b)' : 'var(--color-accent-success, #10b981)';

  return (
    <Tooltip.Root>
      <Tooltip.Trigger asChild>
        <div className={styles.indicator} style={{ color: dotColor }}>
          {!isOnline ? <WifiOff size={14} /> : outboxCount > 0 ? <RefreshCw size={14} className={styles.spinning} /> : <Check size={14} />}
        </div>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content className={styles.tooltip} side="right" sideOffset={8}>
          {label}
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip.Root>
  );
}
